import React from 'react';
import axios from 'axios'
import Cache from '@aws-amplify/cache';

import Register from './register'
import RequestReset from './requestReset'
import ResetPassword from './resetPassword'

import './auth.css'

class Login extends React.Component {
  state = {
    email: '',
    password: '',
    pageView: 'login',
    error: false
  }

  componentDidMount() {
    if (window.location.pathname.split('/')[2] === 'reset') {
      this.setState({ pageView: 'resetPassword' })
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value, error: false })
  }

  showRegisterPage() {
    this.setState({ pageView: 'register' })
  }

  showLogin() {
    this.setState({ pageView: 'login' })
  }

  showResetPassword() {
    this.setState({ pageView: 'requestReset' })
  }

  login() {
    axios.post('/auth/login', {
      email: this.state.email,
      password: this.state.password
    })
      .then(data => {
        console.log(data)
        if (data.token) {
          Cache.setItem('supplier_auth_token', data.token)
          window.location.replace(window.location.pathname.split('/')[1] === 'settings' ? window.location.pathname : '/')
        }
      })
      .catch(err => {
        console.log(err)
        this.setState({ error: true })
      })
  }

  render() {
    return (
      <div>
        {this.state.pageView === 'register' ? <Register showLogin={this.showLogin.bind(this)} /> : null}
        {this.state.pageView === 'requestReset' ? <RequestReset showLogin={this.showLogin.bind(this)} /> : null}
        {this.state.pageView === 'resetPassword' ? <ResetPassword showLogin={this.showLogin.bind(this)} token={window.location.pathname.split('/')[3]} /> : null}
        {this.state.pageView === 'login' ?
          <div className="text-center">
            <form className="form-signin" onSubmit={e => e.preventDefault()}>
              <img className="mb-4" src="/logo.png" alt="" width="300" />
              <h1 className="h3 mb-3 font-weight-normal">Sign in</h1>
              <label for="inputEmail" className="sr-only">Email address</label>
              <input type="email" id="inputEmail" className="form-control input1" placeholder="Email address" name="email" value={this.state.email} onChange={this.handleChange.bind(this)} />
              <label for="inputPassword" className="sr-only">Password</label>
              <input type="password" id="inputPassword" className="form-control input2" placeholder="Password" name="password" value={this.state.password} onChange={this.handleChange.bind(this)} onKeyPress={(e) => {if(e.key === 'Enter'){this.login()}}} />
              {this.state.error ? 
              <div class="alert alert-danger" role="alert">
                Email or password is wrong
              </div> : null }
              <button className="btn btn-lg btn-primary btn-block" type="submit" onClick={this.login.bind(this)}>Sign in</button>
              <p className="mt-1 mb-1"><a href="#fix" onClick={this.showResetPassword.bind(this)}> Reset password</a></p>
              <p className="mt-3 mb-3 text-muted">&copy; {new Date().getFullYear()} OrderFresh</p>
            </form>
          </div>
          : null}
      </div>
    )
  }
}

export default Login;
